import Config from 'components/Config';
// import Theme from 'components/Theme';
import './App.css';

function App() {
	return <Config />;
}

export default App;
